var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9af17",
    d: "M512 308.7c50.6 0 91.7 41.2 91.7 91.7s-41.2 91.7-91.7 91.7c-50.6 0-91.7-41.2-91.7-91.7s41.1-91.7 91.7-91.7m0-57.4c-82.3 0-149.1 66.8-149.1 149.1S429.7 549.5 512 549.5s149.1-66.8 149.1-149.1S594.3 251.3 512 251.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35a4dd",
    d: "M512 157.9c33.7 0 66.4 6.6 97.1 19.6 29.7 12.6 56.4 30.6 79.3 53.5s40.9 49.6 53.5 79.3c13 30.7 19.6 63.4 19.6 97.1 0 34.1-7.8 73.1-23.1 116-13.9 39-34.3 81.5-60.3 126.2-49.3 84.6-109.9 161.1-152 210.4-4.5 5.2-10 6-13 6s-8.7-.8-13.1-6.2C457.6 808.5 396.6 729.4 346.8 644c-26.4-45.3-47-87.8-61.1-126.2-15.4-41.9-23.2-79.1-23.2-110.5 0-33.7 6.6-66.4 19.6-97.1 12.6-29.7 30.6-56.4 53.5-79.3s49.6-40.9 79.3-53.5c30.7-12.9 63.4-19.5 97.1-19.5m0-57.4c-169.5 0-306.9 137.4-306.9 306.9 0 163.3 162 381.8 250.6 489 14.9 18 36.1 27 57.3 27 20.9 0 41.7-8.7 56.6-26.1 88.9-104.1 249.2-316 249.2-489.9.1-169.5-137.3-306.9-306.8-306.9z"
  })));
}

export default SvgMap;